
import { Parent, Family } from "@/types/models";
import { useAuth } from "@/hooks/useAuth";

export const useFamilyUtils = () => {
  const { userRole } = useAuth();
  
  const getFamilyDisplayName = (family: Family, familyParents: Parent[]) => {
    // If the family has a primary parent, use that for display name
    const primaryParent = familyParents.find(p => p.is_primary);
    
    if (primaryParent) {
      // Include primary parent's first initial and last name
      return `${primaryParent.first_name.charAt(0)}. ${primaryParent.last_name} Family`;
    }
    
    // For families without a primary parent, use the family name directly
    // but ensure it ends with " Family" for consistency
    const baseName = family.name.trim();
    if (baseName.endsWith(' Family')) {
      return baseName;
    } else {
      return `${baseName} Family`;
    }
  };

  const isBizOwnerOrAdmin = () => {
    if (!userRole) return false;
    
    console.log(`Checking role permission for: ${userRole}`);
    
    const normalizedRole = userRole.toLowerCase();
    
    const ownerRoles = [
      'bizadmin', 
      'biz_admin',
      'owner',
      'admin',
      'superadmin',
      'super_admin'
    ];
    
    const hasPermission = ownerRoles.some(role => normalizedRole.includes(role));
    console.log(`User has owner/admin permissions: ${hasPermission}`);
    return hasPermission;
  };

  return {
    getFamilyDisplayName,
    isBizOwnerOrAdmin
  };
};

export default useFamilyUtils;
